<template>
  <div
    class="p-3 sm:p-4 bg-gray-700 border-b border-gray-600 flex items-center space-x-2"
  >
    <button
      v-if="showBackButton"
      @click="$emit('back')"
      class="p-2 rounded-full bg-gray-600 text-white hover:bg-gray-500 md:hidden flex-shrink-0"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    <div class="flex-1 min-w-0">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <!-- User info section - always visible -->
        <div class="flex-1 min-w-0 mb-2 sm:mb-0">
          <h2
            class="text-lg sm:text-xl font-semibold text-white truncate"
            v-if="otherUser"
          >
            {{ otherUser.username }}
          </h2>
          <a
            v-if="product"
            :href="`/product/${product.slug}`"
            class="text-sm sm:text-base font-medium text-blue-400 hover:text-blue-300 transition-colors block truncate"
            :title="product.name"
          >
            {{ product.name }}
          </a>
        </div>

        <!-- Action buttons - responsive layout -->
        <div
          class="flex items-center space-x-1 sm:space-x-2 flex-shrink-0"
          v-if="otherUser"
        >
          <!-- Mobile: Icon only buttons -->
          <div class="flex sm:hidden space-x-1">
            <button
              @click="$emit('openRatingModal')"
              class="p-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors"
              title="Oceni korisnika"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z"
                ></path>
              </svg>
            </button>
            <button
              @click="$emit('openBlockModal')"
              class="p-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
              title="Blokiraj korisnika"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
              </svg>
            </button>
          </div>

          <!-- Desktop: Full buttons with text -->
          <div class="hidden sm:flex space-x-2">
            <button
              @click="$emit('openRatingModal')"
              class="px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-sm rounded-md transition-colors flex items-center"
              title="Oceni korisnika"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="mr-1"
              >
                <path
                  d="M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z"
                ></path>
              </svg>
              Oceni
            </button>
            <button
              @click="$emit('openBlockModal')"
              class="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded-md transition-colors flex items-center"
              title="Blokiraj korisnika"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="mr-1"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
              </svg>
              Blokiraj
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ChatHeader',
  props: {
    otherUser: {
      type: Object as PropType<any>,
      default: null,
    },
    product: {
      type: Object as PropType<any>,
      default: null,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['back', 'openRatingModal', 'openBlockModal'],
});
</script>
